export const BOOLEAN_FIELD_YES_LABEL = 'Yes';
export const BOOLEAN_FIELD_NO_LABEL = 'No';
export const BOOLEAN_FIELD_EMPTY_LABEL = '-';
